module.exports = __webpack_public_path__ + "static/media/comisaria.49c000b1.jpg";